<template>
  <div class="row">
    <language-selector />
    <card-update-page :inProgress="inProgress" />
    <card-update-interactive-tags v-if="['place'].indexOf(page.type) !== -1" />
    <card-update-videos v-if="['video'].indexOf(page.type) !== -1" />
    
    <div class="col-12">
      <button
        :disabled="inProgress"
        @click="updatePage(page._id)"
        class="btn btn-primary"
        type="button"
      >
        Update Page
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import { FETCH_ASSET, FETCH_PAGE, PAGE_EDIT } from "@/store/actions.type"
import CkEditor from '@/components/CKEditor'
import CardUpdatePage from '@/pages/PageEdit/CardUpdatePage'
import CardUpdateInteractiveTags from '@/pages/PageEdit/CardUpdateInteractiveTags'
import CardUpdateVideos from '@/pages/PageEdit/CardUpdateVideos'

export default {
  name: "PagesView",

  components: { CardUpdatePage, CardUpdateInteractiveTags, CardUpdateVideos, CkEditor },

  data() {
    return {
      initialPageJSON: null,
      inProgress: false,
    }
  },

  computed: {
    ...mapGetters([
      'langs',
      'page'
    ]),

    currentPageJSON () {
      return JSON.stringify(this.page)
    },

    isPageChanged () {
      return this.currentPageJSON !== this.initialPageJSON
    }
  },

  beforeRouteEnter(to, from, next) {
    Promise.all([
      store.dispatch(FETCH_PAGE, to.params.id),
      store.dispatch('FETCH_ASSETS')
    ]).then(() => {
      next()
    })
  },

  beforeRouteLeave(to, from, next) {
    if (this.isPageChanged) {
      if (window.confirm('Warning! Unsaved changes. Do you really want to leave?')) { 
        next()
      }
    } else {
      next()
    }
  },

  mounted () {
    this.initialPageJSON = JSON.stringify(this.page)
  },

  methods: {
    updatePage(id) {
      this.inProgress = true
      this.$store
        .dispatch(PAGE_EDIT, this.page)
        .finally(() => {
          this.inProgress = false
          this.$store.dispatch(FETCH_PAGE, this.page._id)
            .then(() => {
              this.initialPageJSON = JSON.stringify(this.page)
            })
        })
    },
  }
}
</script>
